// Global flag to suppress cart change handling
window.suppressCartChange = false;

//Add REMOVE GIFT PRODUCT, cartObject is deprecated
window.addRemoveGiftProduct = function addRemoveGiftProduct(CartObject, reloadPage = false) {
  // Stop if we're in a suppressed update
  if (window.suppressCartChange) return;

  function isEmptyObject(obj) {
    return JSON.stringify(obj) === '{}'
  }

  const items_to_add = [];
  const items_to_remove = {};
  let freeProducts = window.theme.custom.freeProducts;
  let data = null;
  let cartUrl = null;

  //console.debug(window.theme.custom.freeProducts);

  window.suppressCartChange = true;

  window.createCartPromise().then(cart => {
    // CartObject parameter override
    CartObject = cart;

    //console.debug("Checking cart", cart);

    cartTotal = CartObject.total_price
    //console.debug("Total", cartTotal);

    // Add items to cart if Cart total is high than minimun Value
    if (CartObject.items.length > 0) {
      let wonaGiftIds = CartObject.items.filter(item => item.properties['_recharge_gift_variant_id']).map(item => item.properties['_recharge_gift_variant_id']);

      wonaGiftIds = wonaGiftIds.filter(id => cart.items.every(item => item.id != id));

      wonaGiftIds.forEach(id => {
        items_to_add.push({ id: id, quantity: 1, properties: { "_recharge_gift": (new Date()).getTime() } });
      });

      const rechargeGifts = CartObject.items.filter(item => item.properties['_recharge_gift']);
      rechargeGifts.forEach(gift => {
        let parrentProduct = cart.items.find(item => {
          return (item.properties['_recharge_gift_variant_id'] == gift.id)
        });
        if (!parrentProduct || (parrentProduct && (!parrentProduct.selling_plan_allocation || !parrentProduct.selling_plan_allocation.selling_plan))) {
          items_to_remove[gift.id] = 0;
        }
      })

      let cartItemId = [];
      for (let item of CartObject.items) {
        cartItemId.push(item.variant_id)
      }

      //console.debug("Checking for free products", freeProducts);

      freeProducts.forEach(productBase => {
        let variantId = productBase.product?.variants[0].id;
        if (productBase.variantId){
          variantId = productBase.variantId;
        }
        if (!variantId || variantId === '') return;

        let isAdded = CartObject.items.map(item => item.id).find(id => (id == variantId));
        let neededCartTotal = productBase.amount * 100;

        //console.debug(`Checking product ${variantId}: cartTotal=${cartTotal}, neededCartTotal=${neededCartTotal}, isAdded=${isAdded}`);

        if (cartTotal < neededCartTotal && isAdded){
          let product = CartObject.items.find(item => item.id == variantId);
          if (product && product.properties && product.properties['_gift']) {
            items_to_remove[variantId] = 0;
          }
        }
        //console.debug("Checking for add");
        if (cartTotal >= neededCartTotal && cartItemId.indexOf(variantId) === -1) {
          const upsellModal = document.querySelector('#upsell-modal[data-upsell-action="add"]');

          items_to_add.push({ id: variantId, quantity: 1, properties: { "_gift": (new Date()).getTime() } });
          //console.debug("Product added to list", variantId);
          // if (upsellModal) {
          //   items_to_add.push({ id: variantId, quantity: 1, properties: { "_gift": (new Date()).getTime() } });
          // }
        }
      });

      let sectionsToBundle = ["variant-added"];
      document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));

      let makeUpdate = false;
      if (!isEmptyObject(items_to_remove)) {
        data = {
          updates: items_to_remove,
          attributes: {
            cartFreeGiftsTotal: items_to_add.length - Object.keys(items_to_remove).length
          }
        };
        cartUrl = `${window.Shopify.routes.root}cart/update.js`;
        makeUpdate = true;
      }

      if (items_to_add.length) {
        data = {
          items: items_to_add,
          attributes: {
            cartFreeGiftsTotal: items_to_add.length
          }
        };
        cartUrl = `${window.Shopify.routes.root}cart/add.js`;
        // data.sections_url = `${Shopify.routes.root}variants/${items_to_add[0].id}`;
      }

      if (data != null) {
        //console.log('Slukhai: data !== null');
        data.sections = sectionsToBundle.join(",");
        window.suppressCartChange = true;

        // Suppress cart change events during this fetch
        // alert('001 suppressCartChange = true;')
        window.suppressCartChange = true;
        fetch(cartUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data)
        })
          .then((res) => res.json())
          .then((responseJson) => { // Corrected this line
            // alert('002 suppressCartChange = true;')
            suppressCartChange = true; // Reset the flag
            if (reloadPage) {
              window.location.reload();
            } else {
              if (makeUpdate) {
                Object.keys(items_to_remove).forEach(itemId => {
                  document.querySelector(`line-item[data-variant="${itemId}"]`).dispatchEvent(new CustomEvent("line-item:change", {
                    bubbles: true,
                    detail: {
                      quantity: 0,
                      cart: responseJson
                    }
                  }));
                  document.dispatchEvent(new CustomEvent("cart:change", {
                    bubbles: true,
                    detail: {
                      baseEvent: "line-item:change",
                      cart: responseJson,
                    },
                  }));
                });
                // alert('003 suppressCartChange = true;')
                window.suppressCartChange = true;
              } else {
                document.dispatchEvent(new CustomEvent("variant:add", {
                  bubbles: true,
                  detail: {
                    items: responseJson.items || [responseJson],
                    cart: responseJson
                  }
                }));
                document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
                  bubbles: true,
                  detail: {
                    baseEvent: "variant:add",
                    cart: responseJson,
                  },
                }));
                window.createCartPromise().then(cartData => {
                  if (document.querySelector('.header__cart-count cart-count') && cartData.item_count !== 'undefined') {
                    document.querySelector('.header__cart-count cart-count').innerHTML = cartData.item_count;
                  }
                });
                // alert('004 suppressCartChange = true;');
                window.suppressCartChange = true;
              }
            }
          })
          .catch(error => {
            console.error('Error during cart update:', error);
            // alert('005 suppressCartChange = false;')
            window.suppressCartChange = false; // Ensure the flag is reset on error
          })
          .finally(() => {
            window.suppressCartChange = false;
          });

      } else {
        window.suppressCartChange = false;
        if (reloadPage) {
          window.location.reload();
        }
      }
    } else {

      if (reloadPage) {
        window.location.reload();
      }
    }
  })
}

document.addEventListener('DOMContentLoaded', () => {
  Array.from(document.querySelectorAll('label.color-swatch.rounded-full')).forEach((element) => {
    element.addEventListener('click', () => {
      let variant_option__subtitle = element.closest('fieldset').querySelector('.variant-option__subtitle span[data-att="option_subtitle"]');
      const str = element.querySelector('span').innerText;
      const capStr = str[0].toUpperCase() + str.slice(1);
      if (variant_option__subtitle)
        variant_option__subtitle.innerText = capStr;
    });
  });
});

/* vDEV */
document.addEventListener('DOMContentLoaded', () => {
  const openBtns = document.querySelectorAll('[data-show-custom-modal]');

  if (!openBtns.length) {
    return;
  }

  openBtns.forEach(btn => {

    btn.addEventListener('click', () => {

      if(btn.id === 'main-cta-button') {

        if (!btn.hasAttribute('data-show-custom-modal')) {
          return;
        }

        const id = btn.dataset.showCustomModal;
        const modal = document.querySelector('custom-modal#' + id);

        if (modal) modal.classList.add('custom-modal--open');

        document.querySelectorAll('#main-cta-button').forEach(b => b.removeAttribute('data-show-custom-modal'))

        btn.setAttribute('clicked-cta', 'true');

      } else {
        const id = btn.dataset.showCustomModal;
        const modal = document.querySelector('custom-modal#' + id);

        if (modal) modal.classList.add('custom-modal--open');
      }
    });
  });
});
/* /vDEV */

var CustomModal = class extends HTMLElement {
  async connectedCallback() {
    const modal = this;

    this.closeBtns = Array.from(this.querySelectorAll('[data-close]'));
    this.closeBtns.forEach(btn => {
      btn.addEventListener('click', () => btn.hasAttribute('data-end-purchase') ? this.endPurchase() : this.close());

      btn.addEventListener('click', () => {
        modal.setAttribute('data-upsell-action', btn.getAttribute('data-upsell-action'));

        btn.hasAttribute('data-end-purchase') ? this.endPurchase() : this.close()
      });
    })
  }

  close() {
    this.classList.remove('custom-modal--open')
  }

  open() {
    this.classList.add('custom-modal--open')
  }

  endPurchase() {
    const buyButton = document.querySelector('[clicked-cta]');

    if (buyButton !== null && !buyButton.hasAttribute('data-show-custom-modal'))
      buyButton.click();

    this.classList.remove('custom-modal--open')
  }
}

window.customElements.define("custom-modal", CustomModal);



var countDownSection = (() => {
  var startCountDown = (element) => {
    const jsDay = element.querySelector('[js-day]');
    const jsHour = element.querySelector('[js-hour]');
    const jsMinute = element.querySelector('[js-minute]');
    const jsSecond = element.querySelector('[js-second]');

    if (!jsDay || !jsHour || !jsMinute || !jsSecond) return;

    var goalDate = new Date(element.getAttribute('data-goal-date')).getTime();
    var timerId = setInterval(() => {
      var now = new Date().getTime();
      var distance = goalDate - now;

      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      jsDay.innerHTML = days;
      jsHour.innerHTML = hours;
      jsMinute.innerHTML = minutes;
      jsSecond.innerHTML = seconds;

      if (distance < 0) {
        clearInterval(timerId);
      }
    }, 1000);
  }
  var initialize = () => {
    document.querySelectorAll('[js-countdown]').forEach(element => {
      startCountDown(element);
    });
  }
  return {
    init: initialize
  }
})();

var deDEFormat = (() => {
  var initialize = () => {
    document.querySelectorAll('[js-de-DE-format]').forEach(element => {
      element.innerHTML = Number(element.innerHTML).toLocaleString('de-DE');
    });
  }
  return {
    init: initialize
  }
})();

var app = (() => {
  var initialize = () => {
    countDownSection.init();
  }
  return {
    init: initialize
  }
})();

document.addEventListener('DOMContentLoaded', () => {
  app.init();
  deDEFormat.init();
});

// custom quantity Updater plus minus
function updateQuantity(button, change) {
    const lineItem = button.closest("line-item-quantity");
    const quantityInput = lineItem.querySelector(".quantity-input");
    const removeLink = lineItem.querySelector(".link");

    let currentValue = parseInt(quantityInput.value, 10) || 0;
    let maxValue = parseInt(quantityInput.getAttribute("max"), 10) || 214;

    button.classList.add('is-disabled');
    if (change === -1 && currentValue > 1) {
        quantityInput.value = currentValue - 1;
        quantityInput.dispatchEvent(new Event("change", { bubbles: true }));
    } else if (change === -1 && currentValue === 1) {
        removeLink.click();
    } else if (change === 1 && currentValue < maxValue) {
        quantityInput.value = currentValue + 1;
        quantityInput.dispatchEvent(new Event("change", { bubbles: true }));
    }
}

/** vDEV **/
/* [Section] Custom: Image with text */
var CustomImageWithTextTab = class extends HTMLElement {

  settings = {
    tabs: this.parentNode,
    list: document.getElementById(this.parentNode.getAttribute('aria-controls'))
  }

  constructor() {
    super();

    const tab = this;
    const tabLeft = parseInt(tab.getBoundingClientRect().left - tab.parentNode.getBoundingClientRect().left);
    tab.setAttribute('data-left', tabLeft);


    tab.addEventListener('click', this._select);

    if (tab.classList.contains('is-selected')) {
      tab._renderList();

      window.addEventListener('resize', () => {
        tab._renderList();
      });
    }
  }

  _scrollList(position) {
    const i = parseInt(position) - 1;

    const cardX = parseInt(getComputedStyle(this.settings.list).getPropertyValue('--list-items-per-row'));
    const card = this.settings.list.querySelector(`custom-image-with-text-card[data-position="${position}"]`);

    if (card) {
      const scrollCarousel = this.settings.list.closest('scroll-carousel');
      scrollCarousel.scrollLeft = card.getAttribute('data-left');

      const event = new CustomEvent('scroll:edge-nearing');
      scrollCarousel.dispatchEvent(event, {
        detail: {
          position: position
        }
      });
    }
  }

  _renderList() {
    const cards = this.settings.list.querySelectorAll('custom-image-with-text-card');

    if (!cards.length) {
      return false;
    }

    cards.forEach((card) => {
      const cardLeft = parseInt(card.getBoundingClientRect().left - this.settings.list.getBoundingClientRect().left);
      card.setAttribute('data-left', cardLeft);
    });
  }

  _select() {
    const tab = this;
    const tabPosition = tab.getAttribute('data-position');

    const tabs = tab.parentNode;
    const list = document.getElementById(tabs.getAttribute('aria-controls'));

    const selectedTab = this.settings.tabs.querySelector('custom-image-with-text-tab.is-selected');

    if (selectedTab) {
      selectedTab.classList.remove('is-selected');
    }

    tab.classList.add('is-selected');

    this._scrollList(tabPosition);
  }
};

if (!window.customElements.get('custom-image-with-text-tab')) {
  window.customElements.define('custom-image-with-text-tab', CustomImageWithTextTab);
}

var CustomImageWithTextList = class extends HTMLElement {

  constructor() {
    super();

    this._events();
  }

  _events() {
    const list = this;
    const scrollCarousel = list.closest('scroll-carousel');

    scrollCarousel.addEventListener('scroll', () => {
      list._scrollEvent();
    });

    scrollCarousel.addEventListener('scrollend', () => {
      list._scrollEvent();
    });
  }

  _scrollEvent() {
    const list = this;
    const scrollCarousel = list.closest('scroll-carousel');

    const listItemsX = parseInt(getComputedStyle(list).getPropertyValue('--list-items-per-row'));
    list.setAttribute('data-list-items-x', listItemsX);

    const listItems = list.children;

    if (!listItems.length) {
      return false;
    }

    /* Active item */
    let listActiveItemPosition = 1;

    for (let listItemI = 0; listItemI < listItems.length; listItemI++) {
      const listItem = listItems[listItemI];
      // const listItemLeft = parseInt(listItem.getBoundingClientRect().left - list.getBoundingClientRect().left);
      const listItemLeft = listItem.getBoundingClientRect().left;

      if (listItemLeft <= 0) {
        listActiveItemPosition = listItemI + 2;
      }
    }

    const tabs = this.closest('.section').querySelector('custom-image-with-text-tabs');

    const activeTab = tabs.querySelector('custom-image-with-text-tab.is-selected');
    activeTab.classList.remove('is-selected');

    const tab = tabs.querySelector(`custom-image-with-text-tab[data-position="${listActiveItemPosition}"]`);
    tab.classList.add('is-selected');
    /* /Active item */

    tabs.scrollTo({
      left: activeTab.getAttribute('data-left'),
      behavior: 'smooth'
    });
  }
};

if (!window.customElements.get("custom-image-with-text-list")) {
  window.customElements.define("custom-image-with-text-list", CustomImageWithTextList);
}
/* /[Section] Custom: Image with text */
/** /vDEV **/



class FullscreenModal extends HTMLElement {
  constructor() {
    super();

    this.closeButton = this.querySelector('button[data-close]')
    this.video = this.querySelector('video');
    this.addEvents();
  }

  addEvents() {
    this.addEventListener('click', event =>{
      if(event.target === event.currentTarget || event.target.closest("[data-close]")) this.close();
    })
    document.querySelectorAll(`[data-open="${this.id}"]`).forEach((el) => {
      el.addEventListener('click', e => {this.open()})
    })
  }

  open() {
    this.classList.add('visible');
    this.video?.play();

    document.body.classList.add('lock');
  }

  close() {
    this.classList.remove('visible');
    this.video?.pause();

    document.body.classList.remove('lock');
  }
}

if (!window.customElements.get("full-screen-modal")) {
  window.customElements.define("full-screen-modal", FullscreenModal);
}

// Parameter to automatically open the cart when the page loads (/?oc=1)
document.addEventListener('DOMContentLoaded', () => {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('oc') === 'true' || urlParams.get('oc') === '1') {
    setTimeout(() => {
      document.querySelector('.header__icon-list a[aria-controls="cart-drawer"]').click();
    });
  }
});

class ContentDrawer extends HTMLElement {
  constructor() {
    super();
    this.toolbarElement = this.querySelector('.shortcodetoolbar');
    this.popoverElement = document.getElementById('tableofcontents-popup');
    this.button = this.toolbarElement.querySelector('.shortcodetoolbar__item');
    this.closeBtn = this.popoverElement.querySelector('[data-action="close-popup"]');
    this.pageOverlay = document.querySelector('.pageoverlay');
  }

  connectedCallback() {
    const isVisible = this.popoverElement.getAttribute('aria-hidden') === 'false';
    this.button.setAttribute('aria-expanded', isVisible);
    this.button.addEventListener('click', () => {
      const isVisible = this.popoverElement.getAttribute('aria-hidden') === 'false';
      this.popoverElement.setAttribute('aria-hidden', isVisible);
      this.button.setAttribute('aria-expanded', isVisible);
      if (this.pageOverlay) {
        this.pageOverlay.classList.toggle('is-visible', !isVisible);
      }
    });

    this.closeBtn.addEventListener('click', () => {
      this.popoverElement.setAttribute('aria-hidden', 'true');
      this.button.setAttribute('aria-expanded', 'false');
      if (this.pageOverlay) {
        this.pageOverlay.classList.remove('is-visible');
      }
    });
  }
}
customElements.define('content-drawer', ContentDrawer);
class TableOfContents extends HTMLElement {
  constructor() {
    super();
    this.summarys = document.querySelectorAll('.tableofcontents');
    this.summarys = Array.prototype.slice.call(this.summarys);
    this.content = document.querySelector('.article__body');
    this.anchorMap = new Map();
    this.anchors = [];
    this.links = [];
    this.popoverElement = document.getElementById('tableofcontents-popup');
    this.pageOverlay = document.querySelector('.pageoverlay');
    this.activeClass = 'active-link';
    this.announcement_bar = document.querySelector('.top-bar');
    this.headerHeight = this.getHeaderHeight();
  }

  getHeaderHeight() {
    const header = document.querySelector('header');
    const announcementBar = document.querySelector('.top-bar');
    const headerHeight = header ? header.offsetHeight : 0;
    const announcementHeight = announcementBar ? announcementBar.offsetHeight : 0;
    return headerHeight + announcementHeight;
  }

  connectedCallback() {
    const anchors = this.content.querySelectorAll('.anchor');
    anchors.forEach((anchor) => {
      this.anchorMap.set(anchor, []);
      this.anchors.push(anchor);
    });

    this.summarys.forEach((summary) => {
      const links = summary.querySelectorAll('.toc--content-link');
      links.forEach((link) => {
        this.links.push(link);
        const anchor = this.content.querySelector(new URL(link.href).hash);
        if (anchor) this.anchorMap.get(anchor).push(link);
        link.addEventListener('click', (e) => {
          e.preventDefault();
          let aElement = e.target;
          if (aElement.nodeName !== 'A') {
            aElement = e.target.closest('a');
          }
          const targetId = aElement.getAttribute('href').substring(1);
          const target = document.getElementById(targetId);
          const targetPosition = target.getBoundingClientRect().top + window.scrollY;
          const offsetPosition = targetPosition - this.headerHeight;
          if (target) {
            target.scrollIntoView({
              top: offsetPosition,
              behavior: 'smooth'
            });
          }
          // Remove active class from all links
          this.links.forEach(l => l.classList.remove(this.activeClass));
          // Add active class to the clicked link
          aElement.classList.add(this.activeClass);
          let parentElement = aElement.parentElement;
          while (parentElement && !parentElement.classList.contains('popup')) {
            parentElement = parentElement.parentElement;
          }

          if (parentElement) {
            this.popoverElement.setAttribute('aria-hidden', 'true');
            this.pageOverlay.classList.remove('is-visible');
          }
        });
      });
    });
  }
}
customElements.define('table-of-content', TableOfContents);
class TocCollapsible extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
    this.shortcodetoolbar = document.querySelector('.shortcodetoolbar');
    this.lastScrollY = null;
    this.handleScroll = this.handleScroll.bind(this);
  }

  connectedCallback() {
    this.toggleBtn = this.querySelector(".toggle");
    this.content = this.querySelector(".toggle-content");
    this.toggleLabel = this.querySelector(".toggle-label");

    if (!this.toggleBtn || !this.content || !this.toggleLabel) return;

    const isMobile = window.matchMedia("(max-width: 768px)").matches;

    // Get initial state from aria-expanded
    const expandedAttr = isMobile
    ? this.toggleBtn.getAttribute("aria-expanded-mobile")
    : this.toggleBtn.getAttribute("aria-expanded");

    this.isOpen = expandedAttr === "true";

    // Override if on mobile and NOT below banner (force closed)
    if (isMobile && !this.classList.contains('toc-below-banner')) {
      this.isOpen = false;
      this.toggleBtn.setAttribute("aria-expanded", "false");
    }

    this.labelOpen = this.toggleLabel.getAttribute("toggle-label-open") || "Show";
    this.labelClose = this.toggleLabel.getAttribute("toggle-label-close") || "Hide";

    // Set initial display and label
    if (this.isOpen) {
      this.content.style.display = "block";
      this.toggleLabel.textContent = this.labelClose;
    } else {
      this.content.style.display = "none";
      this.toggleLabel.textContent = this.labelOpen;
    }

    this.toggleBtn.addEventListener("click", (e) => {
      e.preventDefault();

      if (this.isOpen) {
        this.slideUp(this.content);
        this.toggleLabel.textContent = this.labelOpen;
        this.toggleBtn.setAttribute("aria-expanded", "false");
      } else {
        this.slideDown(this.content);
        this.toggleLabel.textContent = this.labelClose;
        this.toggleBtn.setAttribute("aria-expanded", "true");
      }

      this.isOpen = !this.isOpen;
    });

    window.addEventListener("scroll", this.handleScroll);
    this.handleScroll();

    if (isMobile && !this.classList.contains('toc-below-banner')) {
      const links = this.querySelectorAll(".toc--content-link");
      links.forEach(link => {
        link.addEventListener("click", () => {
          if (this.isOpen) {
            this.slideUp(this.content);
            this.toggleLabel.textContent = this.labelOpen;
            this.toggleBtn.setAttribute("aria-expanded", "false");
            this.isOpen = false;
          }
        });
      });
    }
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  slideDown(element, duration = 300) {
    element.style.display = "block";
    element.style.height = "0px";
    const fullHeight = element.scrollHeight;
    let start = null;

    function animate(timestamp) {
      if (!start) start = timestamp;
      const progress = timestamp - start;
      const height = Math.min((progress / duration) * fullHeight, fullHeight);
      element.style.height = height + "px";

      if (progress < duration) {
        requestAnimationFrame(animate);
      } else {
        element.style.height = "";
      }
    }
    requestAnimationFrame(animate);
  }

  slideUp(element, duration = 300) {
    const fullHeight = element.scrollHeight;
    let start = null;

    function animate(timestamp) {
      if (!start) start = timestamp;
      const progress = timestamp - start;
      const height = Math.max(fullHeight - (progress / duration) * fullHeight, 0);
      element.style.height = height + "px";

      if (progress < duration) {
        requestAnimationFrame(animate);
      } else {
        element.style.display = "none";
        element.style.height = "";
      }
    }
    requestAnimationFrame(animate);
  }

  handleScroll() {
    if (!this.closest('.shortcodetoolbar')) return;
    const currentScrollY = window.scrollY;
    const pageContent = document.querySelector(".page-content");
    const pageContentTop = pageContent?.offsetTop || 0;

    if (currentScrollY >= pageContentTop) {
      this.shortcodetoolbar.classList.remove("fixed");
    } else if ( currentScrollY < pageContentTop) {
      this.shortcodetoolbar.classList.add("fixed");
    }
  }
}
customElements.define('toc-collapsible', TocCollapsible);


// js for highlight menu scroller

(function (){
    var BrandScrollerHelper = {
        addScrollerButtons: function () {
            var brandCollectionWrapEl = document.querySelector('.story-highlight-menu__wrap');

            if(brandCollectionWrapEl){
                brandCollectionWrapEl.insertAdjacentHTML('afterbegin', '<div class="brand-scroll-btn-wrapper left"><button class="brand-scroll-btn" type="button" aria-label="Scroll left"><svg xmlns="http://www.w3.org/2000/svg" width="9" height="14" viewBox="0 0 9 14" fill="none"><path d="M8.83789 2.04395L4.0879 6.79517L8.83789 11.5464L6.79395 13.5903L6.01907e-06 6.79517L6.79395 -8.93437e-08L8.83789 2.04395Z" fill="#333335"/></svg></button></div>');

                brandCollectionWrapEl.insertAdjacentHTML('beforeend', '<div class="brand-scroll-btn-wrapper right"><button class="brand-scroll-btn" type="button" aria-label="Scroll right"><svg xmlns="http://www.w3.org/2000/svg" width="9" height="14" viewBox="0 0 9 14" fill="none"><path d="M-5.04709e-07 2.04395L4.74999 6.79517L-8.93437e-08 11.5464L2.04394 13.5903L8.83788 6.79517L2.04394 -8.93437e-08L-5.04709e-07 2.04395Z" fill="#333335"/></svg></button></div>')
            }
        },
        addEvents: function () {

            var wrap = document.querySelector('.story-highlight-menu__wrap');
            if (!wrap) return;

            var scroller = wrap.querySelector('.story-highlight-menu__inner');
            if (!scroller) return;

            var btnLeft  = wrap.querySelector('.brand-scroll-btn-wrapper.left');
            var btnRight = wrap.querySelector('.brand-scroll-btn-wrapper.right');

            if (!btnLeft || !btnRight) return;

            var scrollAmount = 180;

            function updateButtons() {
                var maxScrollLeft = scroller.scrollWidth - scroller.clientWidth;

                if (maxScrollLeft <= 0) {
                    btnLeft.style.display  = 'none';
                    btnRight.style.display = 'none';
                    return;
                }

                btnLeft.style.display = scroller.scrollLeft > 0 ? 'block' : 'none';
                btnRight.style.display = scroller.scrollLeft < maxScrollLeft - 1 ? 'block' : 'none';
            }

            function scrollToActiveItem() {
                var activeItem = scroller.querySelector('.story-highlight-menu__link.active');
                if (!activeItem) return;

                var itemLeft   = activeItem.offsetLeft;
                var itemWidth  = activeItem.offsetWidth;
                var wrapWidth  = scroller.clientWidth;

                var target = itemLeft - (wrapWidth / 2) + (itemWidth / 2);

                scroller.scrollTo({
                    left: Math.max(0, target),
                    behavior: 'auto'
                });
            }

            btnLeft.addEventListener('click', function () {
                scroller.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
            });

            btnRight.addEventListener('click', function () {
                scroller.scrollBy({ left: scrollAmount, behavior: 'smooth' });
            });

            scroller.addEventListener('scroll', updateButtons);
            window.addEventListener('resize', updateButtons);

            scrollToActiveItem();
            updateButtons();

        },
        init: function () {
            BrandScrollerHelper.addScrollerButtons();
            BrandScrollerHelper.addEvents();
        },
    };
    (function pollForHorizontalScrollingIcon() {
        if (document.querySelector('.story-highlight-menu__wrap .story-highlight-menu__link.active')) {
            BrandScrollerHelper.init();
        } else {setTimeout(pollForHorizontalScrollingIcon, 30);}
    })();
})();

(function () {
    (function pollForBrandLinks() {
        const links = document.querySelectorAll('.story-highlight-menu__link');
        if (links.length) {
            const currentUrl = window.location.pathname.replace(/\/$/, '').toLowerCase();
            let hasActive = false;

            links.forEach(link => {
                const linkUrl = new URL(link.href, window.location.origin).pathname.replace(/\/$/, '').toLowerCase();
                if (currentUrl === linkUrl) {
                    link.classList.add('active');
                    hasActive = true;
                } else {
                    link.classList.remove('active');
                }
            });

            if (!hasActive && links.length > 0) {
                links[0].classList.add('active');
            }

        } else {
            setTimeout(pollForBrandLinks, 30);
        }
    })();
})();

// Discount Groups
// Adds compare at price and badges if discount groups are set.
// Data will be set in snippets/exclusive-discounts.liquid

/*
window.discountGroups =
{
    "exclusive": true,
    "groups": [
        {
            "products": [
                {
                    "handle": "knabberhappen-alleinfutter-vegan",
                    "compare_at_price": "34,90 €",
                    "id": 11493795758348,
                    "price": "33,16 €"
                }
            ],
            "discount": 5
        }
    ]
}
 */

window.enableDiscountGroupsOverride = () => {
  if(window.discountGroupsActive) return;
  window.discountGroupsActive = true;

  const groups = window.discountGroups?.groups || [];
  groups.forEach(group => {
    group.products.forEach(product => {
      // Add/update price and compare at price on all product cards with the same handle
      const productCards = document.querySelectorAll(`product-card[handle="${product.handle}"]`);
      productCards.forEach(productCard => {
        const compareAtPriceElement = productCard.querySelector('compare-at-price');
        const priceElement = productCard.querySelector('sale-price');

        if (compareAtPriceElement) {
          compareAtPriceElement.textContent = product.compare_at_price_formatted;
        }
        else {
          const newCompareAtPriceElement = document.createElement('compare-at-price');
          newCompareAtPriceElement.classList.add('text-subdued', 'line-through');
          newCompareAtPriceElement.textContent = product.compare_at_price_formatted;
          if (priceElement) {
            priceElement.insertAdjacentElement('afterend', newCompareAtPriceElement);
          } else {
            productCard.appendChild(newCompareAtPriceElement);
          }
        }

        if (priceElement) {
          priceElement.textContent = product.price_formatted;
          priceElement.classList.remove('text-subdued');
          priceElement.classList.add('text-on-sale');
        }

        // Add badge
        badge = document.createElement('div');
        badge.classList.add('badge');
        badge.classList.add('badge--on-sale');
        badge.classList.add('badge--card-overlay');
        productCard.appendChild(badge);
        badge.textContent = `-${group.discount}%`;

      });
    });
  });

  if(window.discountGroupsSaleURL) {
    const SALE_LINK = window.discountGroupsSaleURL;

    const desktopNav = document.querySelector('.header__link-list > ul');

    if (desktopNav) {
      if (!desktopNav.querySelector('.js-sale-link')) {
        const li = document.createElement('li');
        li.innerHTML = `<a href="${SALE_LINK}" class="bold link-faded-reverse js-sale-link">Sale</a>`;
        desktopNav.prepend(li);
      }

      desktopNav.querySelectorAll('li').forEach((li) => {
        const summary = li.querySelector('details > summary');
        if (summary && summary.textContent.trim() === 'Dein Hund') {
          li.remove();
        }
      });
    }

    const mobileNav = document.querySelector('navigation-drawer .panel__scroller > ul');

    if (mobileNav) {
      if (!mobileNav.querySelector('.js-sale-link')) {
        const li = document.createElement('li');
        li.innerHTML = `<a href="${SALE_LINK}" class="group block w-full js-sale-link">Sale</a>`;
        mobileNav.prepend(li);
      }

      mobileNav.querySelectorAll('li').forEach((li) => {
        const span = li.querySelector('button > span');
        if (span && span.textContent.trim() === 'Dein Hund') {
          li.remove();
        }
      });
    }
  }
}

// Check for the needed cart attribute if exclusive mode is enabled
document.addEventListener('DOMContentLoaded', () => {
  if(window.discountGroups.exclusive) {
    if(window.discountGroupsAttributeSet) {
      window.enableDiscountGroupsOverride();
    }
    else {
      fetch('/cart.js', { cache: "no-store" })
        .then(response => response.json())
        .then(cart => {
          if (cart.attributes && cart.attributes._exclusive_discount) {
            window.enableDiscountGroupsOverride();
          }
        })
        .catch(error => {
          console.error('Error fetching cart data:', error);
        });
    }
  }
  else {
    window.enableDiscountGroupsOverride();
  }
});